'use client';

import React from 'react';
import Play from '@src/components/Icons/Play';
import { VideoEmbedPlayerPropTypes } from '../VideoEmbedPlayer/VideoEmbedPlayer.types';
import Caption from '../Caption/Caption';
const VideoEmbedPlayer: React.FC<VideoEmbedPlayerPropTypes> = ({
  className = '',
  data
}) => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const hasThumbnail = Boolean(data?.thumbnail);
  const isContentful = data?.platform === 'Contentful';
  // Show media (video or iframe) once playing OR when there's no thumbnail to click
  const shouldShowMedia = isPlaying || !hasThumbnail;
  const handlePlay = () => setIsPlaying(true);
  React.useEffect(() => {
    if (isPlaying && videoRef.current) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) playPromise.catch(() => {});
    }
  }, [isPlaying]);
  return <div className={`my-[1.6rem] ${className}`} data-sentry-component="VideoEmbedPlayer" data-sentry-source-file="VideoEmbedPlayer.tsx">
      <div style={{
      position: 'relative',
      width: '100%',
      paddingTop: '56.25%'
    }}>
        {/* Click overlay only if we have a thumbnail and haven’t started */}
        {!isPlaying && hasThumbnail && <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        background: `url(${data!.thumbnail!.url}) no-repeat center center / cover`,
        zIndex: 1
      }} onClick={handlePlay}>
            <Play className='absolute left-1/2 top-1/2 h-auto w-[10%] -translate-x-1/2 -translate-y-1/2' />
          </div>}

        {isContentful ?
      // CONTENTFUL: use <video>
      shouldShowMedia && <video ref={videoRef} style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }} src={data!.embedUrl} poster={data?.thumbnail?.url} loop muted playsInline controls={false} autoPlay={!hasThumbnail} // auto-start when there's no thumbnail
      >
                Sorry, your browser does not support embedded videos.
              </video> :
      // OTHER PLATFORMS: use <iframe>
      shouldShowMedia && <iframe style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }} src={data!.embedUrl} allowFullScreen allow='autoplay; fullscreen; encrypted-media; picture-in-picture' title='Video player' />}
      </div>

      {data?.bodyCopy && <Caption bodyCopy={data?.bodyCopy} />}
    </div>;
};
export default VideoEmbedPlayer;